import { useState } from 'react'
import ClearChoiceMaxBanner from './ClearChoiceMaxBanner'
interface ClearChoiceMaxBannerContainerProps {
    isHomePage?: boolean
}
const ClearChoiceMaxBannerContainer = ({ isHomePage = false }: ClearChoiceMaxBannerContainerProps) => {
    const [isShowClearChoiceMax, setShowClearChoiceMax] = useState(true)
    return (
        <>
            {isShowClearChoiceMax && (
                <ClearChoiceMaxBanner isCross={true} onCrossClick={() => setShowClearChoiceMax(false)} isHomePage={isHomePage} />
            )}
        </>
    )
}

export default ClearChoiceMaxBannerContainer
